import * as React from 'react';
import { IGameStatItem } from './DoomsdayGame';

export interface IDoomsdayStatProps {
  stat: IGameStatItem[];
  onEnd: () => void;
}

export default class DoomsdayStat extends React.Component<IDoomsdayStatProps> {
  public render() {
    return (
      <>
        <div className="row">
          <div className="col" />
          <div className="col-sm-12 col-md-4">
            <table className="table table-borderless">
              <tbody>
                <tr>
                  <th scope="row">Good</th>
                  <td>{this.props.stat.filter(elem => elem.success).length}</td>
                </tr>
                <tr>
                  <th scope="row">Wrong</th>
                  <td>{this.props.stat.filter(elem => !elem.success).length}</td>
                </tr>
                <tr>
                  <th scope="row">Avg. answer time</th>
                  <td>{this.avgAnswerTime(this.props.stat)}s</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="col" />
        </div>
        <div className="row">
          <div className="col" />
          <div className="col text-center">
            <button
              type="button"
              className="btn btn-primary btn-lg m-2"
              onClick={this.props.onEnd}
            >
              Back
          </button>
          </div>
          <div className="col" />
        </div>
      </>
    );
  }

  private avgAnswerTime(stat: IGameStatItem[]) {
    let sum = 0;
    for (const elem of stat) {
      sum += elem.answerTimeMs;
    }
    return Math.round(sum / stat.length) / 1000;
  }
}



// WEBPACK FOOTER //
// ./src/Doomsday/DoomsdayStat.tsx